export type CancerParamAction = 'adopt' | 'write' | 'none';

type CancerParamSyncInput = {
  paramCancerId: string;
  lastSyncedCancerId: string;
  supersededCancerId: string;
  focusId: string;
  productMismatch: boolean;
};

/**
 * Decides who wins when the directory's cancer filter and its URL disagree.
 *
 * The filter is state and the URL mirrors it, so most disagreements are the state moving
 * first and the URL catching up. A link is the other direction: a new, non-empty id arrives
 * that the directory neither holds nor wrote itself. Treating that as stale and writing the
 * old filter back over it is what made a banner press on an already-open directory do
 * nothing. An empty param never counts as a link, so reaching the directory without a
 * cancer type leaves the reader's filter alone.
 *
 * The superseded id is the param the directory just wrote over. It stays in the router for a
 * beat after the write, and an effect that re-runs in that window would read it as a link
 * and undo the reader's pick.
 */
export function getCancerParamAction({
  paramCancerId,
  lastSyncedCancerId,
  supersededCancerId,
  focusId,
  productMismatch,
}: CancerParamSyncInput): CancerParamAction {
  if (
    paramCancerId &&
    paramCancerId !== lastSyncedCancerId &&
    paramCancerId !== supersededCancerId &&
    paramCancerId !== focusId
  ) {
    return 'adopt';
  }

  if (focusId !== paramCancerId || productMismatch) {
    return 'write';
  }

  return 'none';
}
